import { contentTypeToMediaKind } from './media-kind';

const MB = 1024 * 1024;

/** Per-kind Meta (WhatsApp/Instagram) media limits; mirror of the backend `mime.ts`. */
const META_MAX_BYTES_BY_KIND: Record<string, number> = {
  image: 10 * MB,
  audio: 16 * MB,
  video: 100 * MB,
  document: 25 * MB,
};

/** Ceiling for channels not constrained by Meta. */
export const DEFAULT_MAX_UPLOAD_BYTES = 100 * MB;

/** Channel kinds governed by Meta's per-type limits. */
export const META_CHANNEL_KINDS: ReadonlySet<string> = new Set(['whatsapp', 'instagram']);

/** Maximum allowed upload size for a content type on a given channel (mirrors backend). */
export function maxUploadBytes(contentType: string, channelKind?: string): number {
  if (channelKind && !META_CHANNEL_KINDS.has(channelKind)) {
    return DEFAULT_MAX_UPLOAD_BYTES;
  }
  return META_MAX_BYTES_BY_KIND[contentTypeToMediaKind(contentType)] ?? DEFAULT_MAX_UPLOAD_BYTES;
}

export function exceedsSizeLimit(sizeBytes: number, contentType: string, channelKind?: string): boolean {
  return sizeBytes > maxUploadBytes(contentType, channelKind);
}

/** Coerce ConversationView.channel (already a kind enum value) into a channel kind string. */
export function channelKindFromLabel(channel: string): string {
  return channel === 'unknown' ? 'webchat' : channel;
}
